module.exports = __webpack_public_path__ + "static/media/Inviare_Segnalazione.2d09cb04.mp4";